// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1032":"94505f3c","2542":"8fcd82a4","4044":"ea3aeff8","4850":"4b96087f","5991":"07a06cfc"}[chunkId] + ".chunk.css";
};